import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddAirline, AddAirport, AddNewHotel, getAirlineList, getAirportList, getHotelList, getSuggestList, updateAirlineStatus, updateAirportStatus, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";

import { useNavigate } from "react-router-dom";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import debounce from "lodash.debounce";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";



const airlinefilterData = {
    name:null,
    code:null,
    active:null,
    popular:null


}

const AirportList = () => {
  const autoSuggestionRef = useRef(null);
    const [airportList,setAirportList] = useState([]); 
    const [hoteldata,setHotelData] =  useState(airlinefilterData );
  //  const [cityData,setCityData] =  useState(hotelfilterData);
    const [totalPages, setTotalPages] = useState(null);
    const [totalElements, setTotalElements] = useState("");
    const [currPage, setCurrPage] = useState(0);
    const [pageSize, setPageSize] = useState(15);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showHotel,SetShowHotel] = useState(false);
    const [newHotelData, setNewHotelData] = useState({
        code: "",
        name: "",
        city: "",
        country: "",
        countryCode: "",
        northEastLongitude: "",
        northEastLatitude: "",
        southWestLongitude: "",
        southWestLatitude: "",
        active: "",
        popular:false
   
  });
  const [errors, setErrors] = useState({});
  const[loading,setLoading] = useState(false);

    const navigate = useNavigate();

    const handleViewCity = (cityId) => {
      navigate(`/flight/view/airport/${cityId}`); // Navigate to the city details page
    };
    const handleModalInputChange = (e) => {
      const { name, value } = e.target;
      setNewHotelData((prev) => ({
          ...prev,
          [name]: value,
      }));
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        autoSuggestionRef.current &&
        !autoSuggestionRef.current.contains(event.target)
      ) {
        setShowSuggestions(false); // Close the popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!newHotelData.code) newErrors.code = "Code is required";
    if (!newHotelData.name) newErrors.name = "Name is required";
    if (!newHotelData.city) newErrors.city = "City is required";
    if (!newHotelData.country) newErrors.country = "Country Name is required";
    if (!newHotelData.countryCode) newErrors.countryCode = "Country Code is required";
    if (!newHotelData.northEastLongitude) newErrors.northEastLongitude = "North East Longitude is required";
    if (!newHotelData.northEastLatitude) newErrors.northEastLatitude = "North East Latitude is required";
    if (!newHotelData.southWestLongitude) newErrors.southWestLongitude = "South West Longitude is required";
    if (!newHotelData.southWestLatitude) newErrors.southWestLatitude = "South West Latitude is required";
    if (newHotelData.active === "") newErrors.active = "Status is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  
  const fetchSuggestions = debounce((query, identifier,type) => {
      getSuggestList(query, identifier,type)
        .then((resp) => {
          console.log("API Response:", resp?.data.data.suggestions); // Debug response
          if (resp?.data.data.suggestions) {
            setSuggestions([...resp?.data.data.suggestions]);
            setShowSuggestions(true);
           
          } else {
            setSuggestions([]);
            setShowSuggestions(false); // Handle no suggestions case
            
          }
        })
        .catch((error) => console.error("Error fetching suggestions:", error));
    }, 300);

    const handleDetailData = (e) => {
        const { name, value } = e.target;
       
        setHotelData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "name" && value.trim()) {
          fetchSuggestions(value, "air","0"); // Fetch suggestions only when there's a value
        } else{
          setSuggestions([]);
          setShowSuggestions(false);
  
        }
    };

const showHotelList = (page,key = "")=>{
console.log("setDetailData",hoteldata)
let param = {
    page:page,
    code:hoteldata?.code,
  //  name:hoteldata?.name,
   // active:hoteldata?.active,
    popular:hoteldata?.popular,
   
 //   countryCode:"",
  //  cityId:"",
    active:hoteldata?.active
   
}

if(key === "refresh"){

   setHotelData({...hoteldata,name:null,active:null,code:null});
   param=airlinefilterData;

}

     setLoading(true);
    getAirportList(param).then((resp)=>{
       console.log("response",resp);
         setLoading(false);
        if(resp){
            
            setAirportList(resp?.data?.data?.airport?.content);
            setTotalPages(resp?.data?.data?.airport?.totalPages)
        
        }
    


    })
}

const currPageSet = (currentPage) =>{
    showHotelList(currentPage)
setCurrPage(currentPage);
}






useEffect(()=>{
showHotelList(currPage);
},[])


const handleAddHotel = ()=>{
  
  SetShowHotel((prev) => prev ? false: true);

}

const handleSubmit = ()=>{

    if (!validateForm()) return;

 if(newHotelData.active ==="true"){
  newHotelData.active = true
 } else{
  newHotelData.active = false;
}
 
  AddAirport(newHotelData).then((resp)=>{
 if(resp){
    SetShowHotel(false);
    showHotelList(currPage);

 }

  })
}
console.log("errors",errors);

const updateStatus =(id)=>{
updateAirportStatus(id).then((res)=>{
 if(res){
  showHotelList(currPage);

 }

})

}

console.log("hoteldata",hoteldata)

    return(
        <>
         <div className="userlisthead_container">
         <div style={{ padding: "30px" }}>
         <div className="transaction_main_container">
         <div className="userlist_head">
            <div className="userlist_heading">
              <div className="userlist_left">
                <label>Airport List</label>
              </div>
              <button onClick={()=>navigate('/flight/addnewairport')} className="userlist_btn">Add New Airport</button>    

           
            </div>
          </div>
         
               <FilterWrapper>
          <div className="filterBox">
              <div style={{width:"100%"}}>
                <div className="flex align-items gap-20">
                <div style={{position:"relative"}}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                     value={hoteldata?.name || ""}
                     onChange={handleDetailData}
                      maxLength={20}
                     // onKeyDown={handleKeyDown}
                    />
                    { showSuggestions && suggestions.length > 0 && (
                      <div ref={autoSuggestionRef}>
         <AutoSuggestion
    fromCityList={suggestions}
    setCityName={(name) =>
      setHotelData((prev) => ({
        ...prev,
        name: name,
      }))
    }
    setCityId={(id) =>
      setHotelData((prev) => ({
        ...prev,
      code: id, // Set the selected city ID
      }))
    }
   
    setShowCity={setShowSuggestions}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
  />
                      </div>
   
)}
                  </div>
              
                
                  <div className="input-field">
                    <select
                      className="input_select_field"
                      name="active"
                     value={hoteldata?.active}
                      onChange={handleDetailData}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="" selected={hoteldata?.active === null}>Select status</option> 
                     <>
                      <option value={"true"}>ACTIVE</option>
                     <option value={"false"}>INACTIVE</option>
                      </>
                    </select>
                  </div>
                 
                 
                 
                 
                 
                  {/* <div>
                    <input
                      type="text"
                      name="cityId"
                      placeholder="City Id"
                      value={hoteldata?.cityId}
                     // onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="feedSource"
                      placeholder="Feed Source"
                      value={hoteldata?.feedSource}
                     // onChange={(e) => handleDetailData(e, "number")}
                      maxLength={10}
                     // onKeyDown={handleKeyDown}
                    />
                  </div> */}

                 
                 
                  <div className="button">
                    <button
                      className="userlist_btn"
                      onClick={(e) => showHotelList(0, "search")}
                    >
                      Search
                    </button>
                  </div>

                  <div className="button">
                    <button
                      className="refresh-btn"
                      onClick={(e) => showHotelList(0, "refresh")}
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

              </FilterWrapper>
          </div>

          <div className="table-loader">
          {loading && <LocalLoader className="tableLoader" />}
            <TableWrapper className="table-card-wrapper">
              <table className="table">
                <thead>
                  <tr>
                   <th>CODE</th>
                    <th>NAME</th>
                    <th>CITY</th>
                    <th>COUNTRY NAME</th>
                    <th>LAST UPDATE</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                   
                   
                  </tr>
                </thead>
                <tbody>
                    {airportList && 
                    airportList?.map((items)=>{
                          const dateTimeString = items?.lastUpdatedAt;
                           let [date, time] = dateTimeString.split("T");
                           let newTime = time.slice(0, 8);
                        return(
                         <>
                            <tr>
                            <td>{items?.code}</td>
                            <td>{items?.name}</td>
                            <td>{items?.city}</td>
                           
                            <td>{items?.country}</td>
                           
                            <td>{date + " " + newTime}</td>
                            <td>
                            <div
                                    className={`custom-toggle toggle_button ${
                                      items.active === true ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      updateStatus(items.id, items.active)
                                    }
                                    styled={{
                                      margin: "0",
                                      marginRight: "12px",
                                    }}
                                  >
                                    <div className="slider"></div>
                                  </div>
                            </td>


                            <td className="user_action_btn button">
                  <span>
                    <button onClick={() => handleViewCity(items?.id)}>
                    <i class="fa-solid fa-pen-to-square update" aria-hidden="true"></i>
                    </button>
                  </span>
                            </td>
                             </tr>
                         </>


                        )
                      

                    })
                    
                    
                    }

                </tbody>
              </table>
            </TableWrapper>
            </div>
            
            {totalPages > 1 && (
        <Pagination
         items={showHotelList}
          itemsPerPage={pageSize}
          setitemsPerPage={setPageSize}
          currentPage={currPage}
          setcurrentPage={(page)=>currPageSet(page)}
          totalPages={totalPages}
          forcePage={currPage}
        />
      )}
   
            
            
            </div>
        
        
       
        
         </div>
       {showHotel &&  <ModalPopUp>
         <div className="subadmin_container justify-between flex column gap-20" style={{width:"50%"}}>
         <div style={{padding:"30px",flex:"1 1 100%"}}>
            <p>Add New Country</p>
       <div className="flex gap-10">

          <div style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>Code</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Code"
                  name="code"
                 value={newHotelData.code}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.code && (
                  <p className="error fs-12 mt-10">{errors.code}</p>
                )}
              </div>

              <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname">
                  <label>Status</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                   value={newHotelData.active}
                  onChange={handleModalInputChange}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">status</option> 
                     <>
                      <option value={true}>ACTIVE</option>
                     <option value={false}>INACTIVE</option>
                      </>
                    </select>
                  </div>
          </div>
        
        
        
        
        <div className="flex gap-10 mt-10">

        
          <div style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>name</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Name"
                  name="name"
                 value={newHotelData.name}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.name && (
                  <p className="error fs-12 mt-10">{errors.name}</p>
                )}
              </div>

              <div style={{flex:"1 1 50%"}}>
                <div className="labelname">
                  <label>City</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="City"
                  name="city"
                 value={newHotelData.city}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.city && (
                  <p className="error fs-12 mt-10">{errors.city}</p>
                )}
              </div>
    </div>


     
        
    <div className="flex gap-10 mt-10">

        
<div style={{flex:"1 1 50%"}}>
      <div className="labelname">
        <label>Country</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="Name"
        name="country"
       value={newHotelData.country}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.country && (
        <p className="error fs-12 mt-10">{errors.country}</p>
      )}
    </div>

    <div style={{flex:"1 1 50%"}}>
      <div className="labelname">
        <label>Country Code</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="Country Code"
        name="countryCode"
       value={newHotelData.countryCode}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.countryCode && (
        <p className="error fs-12 mt-10">{errors.countryCode}</p>
      )}
    </div>
    </div>

    <div className="flex gap-10 mt-10">

        
<div style={{flex:"1 1 50%"}}>
      <div className="labelname">
        <label>North East Longitude</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="North East Longitude"
        name="northEastLongitude"
       value={newHotelData.northEastLongitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.northEastLongitude && (
        <p className="error fs-12 mt-10">{errors.northEastLongitude}</p>
      )}
    </div>

    <div style={{flex:"1 1 50%"}}>
      <div className="labelname">
        <label>North East Latitude</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="North East Latitude"
        name="northEastLatitude"
       value={newHotelData.northEastLatitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.northEastLatitude && (
        <p className="error fs-12 mt-10">{errors.northEastLatitude}</p>
      )}
    </div>
    </div>

    <div className="flex gap-10 mt-10">

        
<div style={{flex:"1 1 50%"}}>
      <div className="labelname">
        <label>south West Longitude</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="south West Longitude"
        name="southWestLongitude"
       value={newHotelData?.southWestLongitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.southWestLongitude && (
        <p className="error fs-12 mt-10">{errors?.southWestLongitude}</p>
      )}
    </div>

    <div style={{flex:"1 1 50%"}}>
      <div className="labelname">
        <label>South West Latitude</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="South West Latitude"
        name="southWestLatitude"
       value={newHotelData?.southWestLatitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.southWestLatitude && (
        <p className="error fs-12 mt-10">{errors.southWestLatitude}</p>
      )}
    </div>
    </div>

    
    
               <div className="input-field mt-10 " style={{flex:"1 1 50%"}}>
                    <select
                      className="input_select_field"
                      name="active"
                     value={hoteldata?.popular}
                      onChange={handleDetailData}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">Popular</option> 
                     <>
                      <option value={"true"}>Yes</option>
                     <option value={"false"}>No</option>
                      </>
                    </select>
                  </div>
                 

       
         
         

         </div>
       
         <div className="flex gap-10" style={{padding:"30px"}}>
        
         <div>
          <button onClick={handleAddHotel} className="userlist_btn">Cancle</button>
        </div>
        <div>
          <button onClick={handleSubmit} className="userlist_btn">Submit</button>
        </div>
         </div>
         </div>

         </ModalPopUp>}
        
        
        </>
    )

}

export default AirportList;